import { MappingSettings } from "routes/asset-register/plugins/asset-mapping/mapping-settings"
import { MappingWidgets } from "routes/asset-register/plugins/asset-mapping/mapping-widgets"
import { AllMappings } from "routes/asset-register/plugins/asset-mapping/all-mappings"
import { DataChangedBanner } from "routes/asset-register/plugins/asset-mapping/data-changed-banner"
import { StatusMessages } from "routes/asset-register/plugins/asset-mapping/status-messages"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import {
    getMobiliserStage,
    MOBILISER_STAGE_MAPPING,
    MOBILISER_STAGE_PROCESSING_TYPES,
    MOBILISER_STAGE_REVIEW_TYPES,
    MOBILISER_STAGE_SETTINGS,
} from "routes/asset-register/plugins/asset-mapping/mobiliser-stage.mjs"
import { TypeProcessingStage } from "routes/asset-register/plugins/asset-mapping/type-processing-stage"
import { TypeReview } from "routes/asset-register/plugins/asset-mapping/ai-type-review/components/type-review.js"
import { Case, If, Switch } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_MOBILISER_ADVANCED_MAPPING } from "routes/asset-register/plugins/asset-mapping/feature-flag-mobiliser-advanced-mapping.runtime"
import { useEffect } from "react"
import { dismissProcessingSnackbar } from "routes/asset-register/plugins/asset-mapping/plugins/progress-card/progress-card-state"

export function Mobiliser() {
    const { target, isManualMapTab } = useBoundContext()
    const upgradesEnabled = isEnabled(FEATURE_FLAG_MOBILISER_ADVANCED_MAPPING)
    const stage = getMobiliserStage(target?.options, { upgradesEnabled })
    const registerId = target?._id ?? target?.id

    useEffect(clearProcessingSnackbarOncePastProcessing, [stage, registerId])

    if (!upgradesEnabled) {
        return (
            <MappingSettings>
                <DataChangedBanner />
                <MappingWidgets />
                <AllMappings pagination />
            </MappingSettings>
        )
    }

    return (
        <If value={isManualMapTab}>
            <>
                <MappingWidgets />
                <AllMappings pagination />
            </>
            <Else>
                <Switch value={stage}>
                    <Case when={MOBILISER_STAGE_SETTINGS}>
                        <MappingSettings alwaysOpen />
                    </Case>
                    <Case when={MOBILISER_STAGE_PROCESSING_TYPES}>
                        <MappingSettings>
                            <TypeProcessingStage />
                        </MappingSettings>
                    </Case>
                    <Case when={MOBILISER_STAGE_REVIEW_TYPES}>
                        <TypeReview key={registerId ?? "type-review"} />
                    </Case>
                    <Case when={MOBILISER_STAGE_MAPPING}>
                        <>
                            <MappingSettings>
                                <DataChangedBanner />
                                <MappingWidgets />
                                <AllMappings pagination />
                            </MappingSettings>
                            <StatusMessages />
                        </>
                    </Case>
                </Switch>
            </Else>
        </If>
    )

    function clearProcessingSnackbarOncePastProcessing() {
        if (stage === MOBILISER_STAGE_PROCESSING_TYPES) return
        dismissProcessingSnackbar(registerId)
    }
}
